import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationGivingAccountEnvelope } from './types';

export async function getOrganizationGivingAccount(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/giving-account`;

  const response = await api.executeGetRequest<ObjectResponse<OrganizationGivingAccountEnvelope>>(url);

  return response.data;
}
